



















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';

import EditorMD from './libs/editormd';
import * as utils from './libs/utils';

@Component({
    components: {},
})
export default class Toolbar extends Vue {
    @Prop({ type: [Array] })
    private items: Array<any>;

    get leftItems() {
        const idx = this.items.indexOf('||');
        if (idx > -1) {
            return this.items.slice(0, idx);
        }
        return this.items.slice(0);
    }

    get rightItems() {
        const idx = this.items.indexOf('||');
        if (idx > -1) {
            return this.items.slice(idx + 1);
        }
        return [];
    }

    get cm() {
        return (this.$parent as any).cm;
    }

    private isStateItem(item) {
        // 是否是有状态按钮
        return EditorMD.toolbar[item].state === true;
    }

    private getTitle(item) {
        return EditorMD.defaults.lang.toolbar[item] || '';
    }

    private getIcon(item) {
        if (this.isActive(item) && EditorMD.toolbar[item].state) {
            return EditorMD.toolbar[item].iconActive || '';
        }
        return EditorMD.toolbar[item].icon || '';
    }

    private getText(item) {
        return EditorMD.toolbar[item].text || '';
    }

    private getStyle(item) {
        if (this.isActive(item) && EditorMD.toolbar[item].state) {
            return EditorMD.toolbar[item].styleActive || '';
        }
        return EditorMD.toolbar[item].style || '';
    }

    private isHeader(item) {
        return /^h(\d)/.test(item);
    }

    private isActive(item) {
        switch (item) {
            case 'watch':
                return (this.$parent as any).d_watching;
            case 'fullscreen':
                return (this.$parent as any).d_fullscreen;
            case 'preview':
                return (this.$parent as any).d_preview;
        }

        return false;
    }

    // 工具栏相关操作

    private handleClick(name) {
        if (typeof this[name] === 'function') {
            this[name]();

            if (
                name !== 'link' &&
                name !== 'reference-link' &&
                name !== 'image' &&
                name !== 'preformatted-text' &&
                name !== 'watch' &&
                name !== 'preview' &&
                name !== 'search' &&
                name !== 'fullscreen' &&
                name !== 'info'
            ) {
                this.cm.focus();
            }
        }
    }

    private undo() {
        this.cm.undo();
    }

    private redo() {
        this.cm.redo();
    }

    private bold() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();

        cm.replaceSelection('**' + selection + '**');

        if (selection === '') {
            cm.setCursor(cursor.line, cursor.ch + 2);
        }
    }

    private del() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();

        cm.replaceSelection('~~' + selection + '~~');

        if (selection === '') {
            cm.setCursor(cursor.line, cursor.ch + 2);
        }
    }

    private italic() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();

        cm.replaceSelection('*' + selection + '*');

        if (selection === '') {
            cm.setCursor(cursor.line, cursor.ch + 1);
        }
    }

    private quote() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();

        if (cursor.ch !== 0) {
            cm.setCursor(cursor.line, 0);
            cm.replaceSelection('> ' + selection);
            cm.setCursor(cursor.line, cursor.ch + 2);
        } else {
            cm.replaceSelection('> ' + selection);
        }

        //cm.replaceSelection("> " + selection);
        //cm.setCursor(cursor.line, (selection === "") ? cursor.ch + 2 : cursor.ch + selection.length + 2);
    }

    private ucfirst() {
        const cm = this.cm;
        const selection = cm.getSelection();
        const selections = cm.listSelections();

        cm.replaceSelection(utils.firstUpperCase(selection));
        cm.setSelections(selections);
    }

    private ucwords() {
        const cm = this.cm;
        const selection = cm.getSelection();
        const selections = cm.listSelections();

        cm.replaceSelection(utils.ucwords(selection));
        cm.setSelections(selections);
    }

    private uppercase() {
        const cm = this.cm;
        const selection = cm.getSelection();
        const selections = cm.listSelections();

        cm.replaceSelection(selection.toUpperCase());
        cm.setSelections(selections);
    }

    private lowercase() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();
        const selections = cm.listSelections();

        cm.replaceSelection(selection.toLowerCase());
        cm.setSelections(selections);
    }

    private h1() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();

        if (cursor.ch !== 0) {
            cm.setCursor(cursor.line, 0);
            cm.replaceSelection('# ' + selection);
            cm.setCursor(cursor.line, cursor.ch + 2);
        } else {
            cm.replaceSelection('# ' + selection);
        }
    }

    private h2() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();

        if (cursor.ch !== 0) {
            cm.setCursor(cursor.line, 0);
            cm.replaceSelection('## ' + selection);
            cm.setCursor(cursor.line, cursor.ch + 3);
        } else {
            cm.replaceSelection('## ' + selection);
        }
    }

    private h3() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();

        if (cursor.ch !== 0) {
            cm.setCursor(cursor.line, 0);
            cm.replaceSelection('### ' + selection);
            cm.setCursor(cursor.line, cursor.ch + 4);
        } else {
            cm.replaceSelection('### ' + selection);
        }
    }

    private h4() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();

        if (cursor.ch !== 0) {
            cm.setCursor(cursor.line, 0);
            cm.replaceSelection('#### ' + selection);
            cm.setCursor(cursor.line, cursor.ch + 5);
        } else {
            cm.replaceSelection('#### ' + selection);
        }
    }

    private h5() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();

        if (cursor.ch !== 0) {
            cm.setCursor(cursor.line, 0);
            cm.replaceSelection('##### ' + selection);
            cm.setCursor(cursor.line, cursor.ch + 6);
        } else {
            cm.replaceSelection('##### ' + selection);
        }
    }

    private h6() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();

        if (cursor.ch !== 0) {
            cm.setCursor(cursor.line, 0);
            cm.replaceSelection('###### ' + selection);
            cm.setCursor(cursor.line, cursor.ch + 7);
        } else {
            cm.replaceSelection('###### ' + selection);
        }
    }

    private 'list-ul'() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();

        if (selection === '') {
            cm.replaceSelection('- ' + selection);
        } else {
            const selectionText = selection.split('\n');

            for (let i = 0, len = selectionText.length; i < len; i++) {
                selectionText[i] = selectionText[i] === '' ? '' : '- ' + selectionText[i];
            }

            cm.replaceSelection(selectionText.join('\n'));
        }
    }

    private 'list-ol'() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();

        if (selection === '') {
            cm.replaceSelection('1. ' + selection);
        } else {
            const selectionText = selection.split('\n');

            for (let i = 0, len = selectionText.length; i < len; i++) {
                selectionText[i] = selectionText[i] === '' ? '' : i + 1 + '. ' + selectionText[i];
            }

            cm.replaceSelection(selectionText.join('\n'));
        }
    }

    private hr() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        // const selection = cm.getSelection();

        cm.replaceSelection((cursor.ch !== 0 ? '\n\n' : '\n') + '------------\n');
    }

    private tex() {
        if (!(this.$parent as any).tex) {
            alert('settings.tex === false');
            return this;
        }

        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();

        cm.replaceSelection('$$' + selection + '$$');

        if (selection === '') {
            cm.setCursor(cursor.line, cursor.ch + 2);
        }
    }

    private link() {
        const cm = this.cm;
        // const cursor = cm.getCursor();

        cm.replaceSelection('[like title](http://link-url.example.com)');
    }

    // private "reference-link"() {
    //     this.executePlugin("referenceLinkDialog", "reference-link-dialog/reference-link-dialog");
    // }

    private pagebreak() {
        if (!(this.$parent as any).pageBreak) {
            alert('settings.pageBreak === false');
            return this;
        }

        const cm = this.cm;
        // const selection = cm.getSelection();

        cm.replaceSelection('\r\n[========]\r\n');
    }

    private image() {
        const cm = this.cm;
        //
        // cm.replaceSelection("![image](http://image-url.example.com)");
        (this.$parent as any).addImage((url, desc) => {
            cm.replaceSelection(`![${desc}](${url})`);
        });
    }

    private code() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();

        cm.replaceSelection('`' + selection + '`');

        if (selection === '') {
            cm.setCursor(cursor.line, cursor.ch + 1);
        }
    }

    private 'code-block'() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();

        cm.replaceSelection((cursor.ch === 0 ? '' : '\n') + '```python\n' + selection + '\n```\n');
        cm.setCursor(cursor.line + (cursor.ch === 0 ? 1 : 2), cursor.ch + selection.length);
    }

    // private "preformatted-text"() {
    //     this.executePlugin("preformattedTextDialog", "preformatted-text-dialog/preformatted-text-dialog");
    // }

    private table() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        const selection = cm.getSelection();

        cm.replaceSelection(
            (cursor.ch === 0 ? '' : '\n') +
                '| header1     | header2     |\n| ----------- | ----------- |\n| row1 cell1  | row1 cell2  |\n| row2 cell1  | row2 cell2  |\n'
        );
    }

    private datetime() {
        const cm = this.cm;
        const selection = cm.getSelection();
        const date = new Date();
        const langName = EditorMD.defaults.lang.name;
        const datefmt =
            utils.dateFormat() +
            ' ' +
            utils.dateFormat(langName === 'zh-cn' || langName === 'zh-tw' ? 'cn-week-day' : 'week-day');

        cm.replaceSelection(datefmt);
    }

    private emoji() {
        const cm = this.cm;
        const cursor = cm.getCursor();
        cm.replaceSelection(
            (cursor.ch === 0
                ? ''
                : cm.getRange(
                      {
                          line: cursor.line,
                          ch: cursor.ch - 1,
                      },
                      cursor
                  ) === ' '
                ? ''
                : ' ') + ':smile: '
        );
    }

    private 'html-entities'() {
        // this.executePlugin("htmlEntitiesDialog", "html-entities-dialog/html-entities-dialog");
    }

    private 'goto-line'() {
        // this.executePlugin("gotoLineDialog", "goto-line-dialog/goto-line-dialog");
    }

    private fullscreen(e) {
        (this.$parent as any).setFullScreen();
    }

    private preview() {
        (this.$parent as any).preview();
    }

    private watch() {
        (this.$parent as any).watching();
    }

    private help() {
        (this.$parent as any).help();
    }
}
